import { render } from "./TripsPage.vue?vue&type=template&id=9628f752&scoped=true&ts=true"
import script from "./TripsPage.vue?vue&type=script&lang=ts"
export * from "./TripsPage.vue?vue&type=script&lang=ts"

import "./TripsPage.vue?vue&type=style&index=0&id=9628f752&lang=scss&scoped=true"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9628f752"]])

export default __exports__